/* Copyright (c) 2024-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';

import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto';
import { ReadableSpan } from '@opentelemetry/sdk-trace-web';
import { ExportResult } from '@opentelemetry/core';
import { OTLPExporterNodeConfigBase } from '@opentelemetry/otlp-exporter-base';

export class CustomOTLPExporter extends OTLPTraceExporter {
    private _isTracingDisabledReplaySubject: ReplaySubject<boolean>;

    constructor(config: OTLPExporterNodeConfigBase, isTracingDisabledReplaySubject: ReplaySubject<boolean>) {
        super(config);
        this._isTracingDisabledReplaySubject = isTracingDisabledReplaySubject;
    }

    export(items: ReadableSpan[], resultCallback: (result: ExportResult) => void): void {
        this._isTracingDisabledReplaySubject
            .asObservable()
            .pipe(take(1))
            .subscribe((isTracingDisabled: boolean) => {
                if (isTracingDisabled) {
                    return;
                }
                super.export(items, resultCallback);
            });
    }
}
